import React from 'react'
import weatherApp from '../assets/weatherApp.png'
import Contact from './Contact'

const Work = () => {
  return (
    <div>
      <div name="work" className="w-full h-[1000px] bg-[#fffbf3]">
        <div className="max-w-[1000px] mx-auto p-8 flex flex-col justify-center h-full md:pl-4 ">
          <div className="pb-8 md:pl-4 ">
            <p className="text-4xl font-bold inline border-b-4 border-[#907aff]">
              Work
            </p>
            <p className="py-6">Check out some of my recent work</p>
          </div>

          {/* container */}
          <div className="grid sm:grid-cols-2 md:grid-cols-2 gap-24 md:px-4">
            {/* grid item */}
            <div
              style={{ backgroundImage: `url(${weatherApp})` }}
              className="group container rounded-md flex justify-center items-center mx-auto content-div"
            >
              <div className="opacity-0 group-hover:opacity-100">
                <span className="text-2xl font-bold tracking-wider text-[#3c198e]">
                  React Weather Application
                </span>
                <div className="flex justify-between items-center mt-4 font-bold text-lg text-[#56a2fa]">
                  <span>HTML</span>
                  <span>CSS</span>
                  <span>JavaScript</span>
                </div>
                <div className="pt-8 text-center">
                  <a href="/">
                    <button className="text-center rounded-lg px-4 py-3 mx-8 bg-[#907aff] text-white font-bold text-lg hover:bg-[#7fb7f7]">
                      Demo
                    </button>
                  </a>
                  <a href="/">
                    <button className="text-center rounded-lg px-4 py-3 mx-8 bg-[#907aff] text-white font-bold text-lg hover:bg-[#7fb7f7]">
                      Code
                    </button>
                  </a>
                </div>
              </div>
            </div>
            {/* grid item */}
            <div
              style={{ backgroundImage: `url(${weatherApp})` }}
              className="group container rounded-md flex justify-center items-center mx-auto content-div"
            >
              <div className="opacity-0 group-hover:opacity-100">
                <span className="text-2xl font-bold tracking-wider text-[#3c198e]">
                  React Weather Application
                </span>
                <div className="flex justify-between items-center mt-4 font-bold text-lg text-[#56a2fa]">
                  <span>HTML</span>
                  <span>CSS</span>
                  <span>JavaScript</span>
                </div>
                <div className="pt-8 text-center">
                  <a href="/">
                    <button className="text-center rounded-lg px-4 py-3 mx-8 bg-[#907aff] text-white font-bold text-lg hover:bg-[#7fb7f7]">
                      Demo
                    </button>
                  </a>
                  <a href="/">
                    <button className="text-center rounded-lg px-4 py-3 mx-8 bg-[#907aff] text-white font-bold text-lg hover:bg-[#7fb7f7]">
                      Code
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Contact />
      </div>
    </div>
  )
}

export default Work
